<template>
  <div>
    <div class="d-none d-sm-block">
      <div style="position: relative; text-align:center">
        <span class="font-backward session_name font-weight-bold" style="position: absolute; bottom: 10px; right: 0; left: 90px; color: white">
          INICIAR SESIÓN
        </span>
        <img class="img-session_name" src="@/assets/store/home/session_name.png" alt="">
      </div>
    </div>

    <form class="text-center mt-50">
      <div class="form-group col-sm-12">
        <label class="color-blue font-general-r h5 font-weight-bold" for="name">Correo electrónico</label>
        <input v-model="user.email" name="email" v-validate="'required|email'" data-vv-as="Correo" type="email" class="input-nv" id="name">
        <br>
        <span v-show="errors.has('email')" class="text-danger mt-2">
          {{ errors.first("email") }}
        </span>
      </div>

      <div class="form-group col-sm-12 text-center">
        <label for="lastname" class="color-blue font-general-r h5 font-weight-bold">Contraseña</label>
        <input @keyup.enter="login" name="password" v-validate="'required'" data-vv-as="Contraseña" v-model="user.password" type="password" class="input-nv" id="lastname">
        <br>
        <span v-show="errors.has('password')" class="w-100 text-danger mt-2">
          {{ errors.first("password") }}
        </span>
      </div>

      <v-btn href="/recuperar-contraseña" class="mt-2 nv-btn-large font-weight-bold" text elevation="0" color="accent">¿Olvidaste tu contraseña?</v-btn> <br>

      <v-btn :loading="loading" @click="login" elevation="0" color="primary" class="nv-btn nv-btn-large mt-10 nv-btn-hover">ENTRAR</v-btn> <br>
      <v-btn to="/registro" text elevation="0" color="accent" class="mt-5 font-weight-bold">CREAR CUENTA</v-btn>

    </form>
  </div>
</template>

<script>
import HomeService from '@/services/home.service'
export default {
  props: ['redirect'],
  data: () => ({
    user: {
      email: '',
      password: ''
    },
    loading: false
  }),
  methods: {
    login() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          try {
            this.loading = true
            const { data:res } = await HomeService.login(this.user)

            if (res.success) {
              await this.$store.dispatch('setUser', res.data.user)
              localStorage.setItem('token', res.data.token)
              this.$store.dispatch('setCart')

              //si el usuario ya tiene una suscripcion y intenta hacer una nueva
              if (res.data.user.subscription) {
                if (this.redirect == '/procesar-suscripcion') {
                  this.$router.push({ path: '/', query: { exs: 'exs' } })
                  return false
                }
              }
              setTimeout(() => {
                this.$router.push(this.redirect)
              }, 1000)
            } else {
              this.loading = false
              this.$swal(res.error, '', 'warning');
            }
          } catch (e) {
            this.loading = false
            this.$swal('Ops! Nieve de olla no esta disponible en este momento', '', 'warning');
          }
        } else {
          console.log('r')
        }
      })

    }
  }
}
</script>
